import {TriggerPropertiesErrors} from './trigger-properties-errors';
import {TranslocoService} from '@ngneat/transloco';
import {CsvErrors} from '../../../shared/csv-validation/csv-errors';
import {TriggerPersistRequestCsv} from '../../../model/import-csv/trigger-persist-request-csv';
import {Inject} from '@angular/core';

export class TriggerCsvErrors extends CsvErrors<TriggerPropertiesErrors, TriggerPersistRequestCsv> {
  constructor(@Inject(TranslocoService) i18n: TranslocoService) {
    super(i18n, TriggerPropertiesErrors);
  }

  public isDeviceOrAsset(object: TriggerPersistRequestCsv, property: string) {
    const validValue: string[] = ['ASSET', 'DEVICE'];
    if (object[property] == null || !validValue.includes(object[property])) {
      this.addCsvMachineError(property, {
        message: 'isNotDeviceOrAsset',
        params: {
          field: this.propertiesErrors.getTranslation(property).toLowerCase(),
          value: object[property],
        }
      });
    }
    return null;
  }

  public validOperation(object: TriggerPersistRequestCsv, property: string) {
    const validValue: string[] = ['GT', 'GTE', 'LT', 'LTE', 'EQ', 'BYTE_MASK', 'INACTIVITY'];
    if (object[property] == null || !validValue.includes(object[property])) {
      this.addCsvMachineError(property, {
        message: 'noValidOperation',
        params: {
          field: this.propertiesErrors.getTranslation(property).toLowerCase(),
          value: object[property],
        }
      });
    }
    return null;
  }

  public validValue(object: TriggerPersistRequestCsv, property: string) {
    const validValue: string[] = ['GT', 'GTE', 'LT', 'LTE', 'EQ', 'BYTE_MASK', 'INACTIVITY'];
    const indexOperation: number = validValue.indexOf(object['operation']);
    const operation: string = indexOperation === -1 ? undefined : validValue[indexOperation];

    if (operation !== undefined && (object[property] == null || !this.isValidValue(operation, object[property]))) {
      this.addCsvMachineError(property, {
        message: 'noValidValue',
        params: {
          field: this.propertiesErrors.getTranslation(property).toLowerCase(),
          value: object[property],
        }
      });
    }
    return null;
  }

  private isValidValue(operation: string, value: string): boolean {
    switch (operation) {
      case 'GT':
      case 'GTE':
      case 'LT':
      case 'LTE':
        return !isNaN(Number(value));
      case 'EQ':
        return typeof value === 'string';
      case 'BYTE_MASK': {
        const numberByteMask: number = Number(value);
        return Number.isSafeInteger(numberByteMask) && numberByteMask <= 4294967295;
      }
      case 'INACTIVITY': {
        const numberInactivity: number = Number(value);
        return Number.isSafeInteger(numberInactivity);
      }
      default:
        return false;
    }
  }

}
